// Owner in P4: piece 4 "ideas" (docs/FILE-OWNERSHIP.md, "The P4 pieces").
// The feature's entry file (docs/CONTRACTS.md sections 16 and 22.6): `/ideas`, one lazy chunk. The URL carries ids and codes only: the
// open card's id (`idea`) and an offer family code (`family`), read by search.ts.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Lightbulb } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { parseSearch } from './search.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/ideas',
      validateSearch: (search: Record<string, unknown>) => parseSearch(search),
      component: lazyRouteComponent(() => import('./IdeasScreen.tsx')),
    }),
  ],
  nav: [{ to: '/ideas', label: 'nav.ideas', icon: Lightbulb, group: 'later', key: 'i' }],
}
